import tw, { styled } from 'twin.macro'

type PasswordEyeButtonProps = {
  $visible: boolean
  $error?: any
}

export const PasswordEyeButton = styled.button(
  ({ $visible, $error }: PasswordEyeButtonProps) => [
    tw`
      focus:outline-none
      focus-visible:ring-2
      focus-visible:rounded-md
      focus-visible:border-brand-subdued
    `,
    $visible
      ? $error
        ? tw`text-red-500`
        : tw`text-brand-neutral`
      : $error
      ? tw`text-red-200`
      : tw`text-gray-300`,
  ],
)
